// Runtime endpoints. Injected by vite.config.ts from the repo-root .env (API_URL, GATEWAY_URL, SITE_URL);
// the desktop shell overrides them through window.moodsDesktop.config (Phase 12 bridge, packages/shared desktop.ts).
import type { MoodsDesktopBridge } from '@moods/shared';

declare global {
  interface Window {
    moodsDesktop?: MoodsDesktopBridge;
  }
}

const desktop = typeof window !== 'undefined' ? window.moodsDesktop?.config : undefined;

export const API_URL: string = (desktop?.apiUrl ?? import.meta.env.VITE_API_URL ?? 'http://localhost:4000').replace(/\/$/, '');
export const GATEWAY_URL: string = desktop?.gatewayUrl ?? import.meta.env.VITE_GATEWAY_URL ?? 'ws://localhost:4000/gateway';
export const SITE_URL: string = (desktop?.siteUrl ?? import.meta.env.VITE_SITE_URL ?? 'http://localhost:4321').replace(/\/$/, '');
export const IS_DESKTOP = typeof window !== 'undefined' && Boolean(window.moodsDesktop);
export const PLATFORM: 'web' | 'desktop-win' | 'desktop-mac' | 'mobile-web' = IS_DESKTOP
  ? window.moodsDesktop?.platform === 'darwin'
    ? 'desktop-mac'
    : 'desktop-win'
  : typeof navigator !== 'undefined' && /Mobi|Android|iPhone/.test(navigator.userAgent)
    ? 'mobile-web'
    : 'web';
